import { AccountWrenchOutlineIcon } from './AccountWrenchOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 9AD54A3C-987A-4ED9-A416-7432C9540239
 * name account-wrench-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-wrench-outline.svg
 * tags
 * - Account / User 
 */
export const AccountServiceOutlineIcon = AccountWrenchOutlineIcon;
export default AccountServiceOutlineIcon